import { EndExamModalController } from 'Core/ModalCore/Modals/EndExamModalController'
import { ActionConfig, ActionContext, IAction } from '../Action'

export class EndExamAction implements IAction {
    static Id = 'EndExam' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.addAction(
            {
                id: 'end-exam',
                title: this.config?.title ?? 'End Exam',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (() => {
                        this.actionContext.modalManager?.showModal(EndExamModalController.Id)
                    }),
                color: 'danger',
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.removeAction('end-exam')
    }
}
